module.exports = __webpack_public_path__ + "static/img/telegram-modal-guide-img.68dbb47.png";